document.addEventListener('click', (e) => {
	const button = e.target.closest('.topbar-menu__sub-menu-button');
	const tbActiveMenuItem = document.querySelectorAll(
		'.topbar-menu li.active'
	);

	// If clicking outside the menu — close everything
	if (!button && !e.target.closest('.topbar-menu')) {
		tbActiveMenuItem.forEach((item) => item.classList.remove('active'));
		document.body.classList.remove('active');
		return;
	}

	if (!button) return;

	e.preventDefault();

	const li = button.closest('li');
	if (!li) return;

	const isActive = li.classList.toggle('active');
	document.body.classList.toggle('active', isActive);

	tbActiveMenuItem.forEach((item) => {
		if (item !== li) item.classList.remove('active');
	});
});

